import {
  SUCCESS_ACCOUNT_SUMMARY_RESULT,
  UpdateType,
} from "@/generated/TradingGateway"

import type {
  AccountSummary,
  AccountSummaryUpdate,
  SuccessAccountSummaryResult,
} from "../AccountService"

export const MOCK_ACCT_NUM = "123456789"

const mockAccountSummary: AccountSummary = {
  accountNumber: MOCK_ACCT_NUM,
  cash: "1215.35",
  buyingPower: "1215.35",
  portfolioValue: "1524.67",
}

const toSuccess = (
  updateType: UpdateType,
  payload: AccountSummary,
): SuccessAccountSummaryResult => ({
  type: SUCCESS_ACCOUNT_SUMMARY_RESULT,
  payload: { updateType, payload } satisfies AccountSummaryUpdate,
})

export const mockAccountEvents: SuccessAccountSummaryResult[] = [
  toSuccess(UpdateType.StateOfTheWorld, mockAccountSummary),
  toSuccess(UpdateType.Updated, mockAccountSummary),
]
